import {takeEvery, put, fork, call, all, /*select*/ } from 'redux-saga/effects';
import { actions as serviceReducerActions, callTypes } from "./serviceSlice";
import { getAllServicesForDeptInProvApi, searchServicesForDeptForProvApi } from "./serviceAPI";
import * as uis from "../../../UI/redux/uiSlice";

export function* onLoadDeptServicesStartAsync({payload}){

    try{
        
        yield put(serviceReducerActions.startCall({ callType: callTypes.list }));

        // const getAuth = (state) => state.auth;
        // const auth = yield select(getAuth);

        // let reqBody = {
        //     username: auth.userName,
        //     sessionKey: auth.sessionKey,
        //     deptId: payload.deptId
        // };

        // const response = yield call(getAllServicesForDeptApi, reqBody);

        let reqBody = {
            idOne: payload.provId,
            idTwo: payload.deptId
        };

        const response = yield call(getAllServicesForDeptInProvApi, reqBody);        

        if(response.status === 200){
            let entities = response.data;
            let totalCount = entities.length;
            yield put(serviceReducerActions.servicesLoaded({entities, totalCount}));
        }
    }
    catch(error){

        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error retrieving the service information."
        // }));

        yield put(serviceReducerActions.catchError({
            callType: callTypes.list,
            error: "There was an error retrieving the service information."
        }));

    }

};

export function* onSearchDeptServicesStartAsync({payload}){

    try{
        
        yield put(serviceReducerActions.startCall({ callType: callTypes.list }));

        // const getAuth = (state) => state.auth;
        // const auth = yield select(getAuth);

        // let reqBody = {
        //     username: auth.userName,
        //     sessionKey: auth.sessionKey,
        //     deptId: payload.deptId,
        //     query: payload.query
        // };

        // const response = yield call(searchServicesForDeptApi, reqBody);

        let reqBody = {
            idOne: payload.provId,
            idTwo: payload.deptId,
            str: payload.query.str
        };

        const response = yield call(searchServicesForDeptForProvApi, reqBody);        

        if(response.status === 200){
            let entities = response.data;
            let totalCount = entities.length;
            yield put(serviceReducerActions.servicesLoaded({entities, totalCount}));
        }
    }
    catch(error){

        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error while searching for the service information."
        // }));

        yield put(serviceReducerActions.catchError({
            callType: callTypes.list,
            error: "There was an error while searching for the service information."
        }));

    }

};


export const actionTypes = {
    FetchAllServsForDept: "[FetchAllServsForDept] Fetch All Services for Dept API Action",
    SearchServsForDept: "[SearchServsForDept] Search Services for Dept API Action",

};

export const actions = {

    fetchAllServsForDept: (deptId, provId) => ({ type: actionTypes.FetchAllServsForDept, payload: { deptId, provId } }),
    searchServsForDept: (deptId, query, provId) => ({ type: actionTypes.SearchServsForDept, payload: { deptId, query, provId } }),


};

export function* fetchAllServsForDept(){

    yield takeEvery(actionTypes.FetchAllServsForDept,onLoadDeptServicesStartAsync);    
};

export function* searchServsForDept(){

    yield takeEvery(actionTypes.SearchServsForDept,onSearchDeptServicesStartAsync);    
};



const fSagas = [
    fork(fetchAllServsForDept),
    fork(searchServsForDept),

];

export function* saga(){
    yield all ([...fSagas]);
};




